export { ResourceHubSection as HelpCenterLayout } from "../expanded-section-pack"